// import { useQuery } from "@tanstack/react-query";
// import { cmsServices } from "features/cms/services/cms.service";

// export const useCmsPages = ({page, limit, status, pageType, search, sortBy, sortOrder,}) => {
//   return useQuery({
//     queryKey: [
//       "cmsPages",
//       { page, limit, status, pageType, search, sortBy, sortOrder },
//     ],
//     queryFn: () =>
//       cmsServices.getCmsPages({
//         page,
//         limit,
//         status,
//         pageType,
//         search,
//         sortBy,
//         sortOrder,
//       }),
//     staleTime: 5 * 60 * 1000, // 5 minutes
//     gcTime: 10 * 60 * 1000, // 10 minutes
//     keepPreviousData: true,
//   });
// };

// export const useCmsPage = (cmsPageId) => {
//   return useQuery({
//     queryKey: ["cmsPages", cmsPageId],
//     queryFn: () => cmsServices.getCmsPageById(cmsPageId),
//     enabled: !!cmsPageId,
//     staleTime: 5 * 60 * 1000,
//   });
// };

import { useQuery } from '@tanstack/react-query';
import { cmsServices } from 'features/cms/services/cms.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get all CMS pages
 */
export const useCmsPages = ({
  page,
  limit,
  status,
  pageType,
  search,
  sortBy,
  sortOrder,
}) => {
  return useQuery({
    queryKey: [
      'cmsPages',
      {
        page,
        limit,
        status,
        pageType,
        search,
        sortBy,
        sortOrder,
      },
    ],

    queryFn: async () => {
      try {
        return await cmsServices.getCmsPages({
          page,
          limit,
          status,
          pageType,
          search,
          sortBy,
          sortOrder,
        });
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes

    placeholderData: (previousData) => previousData,

    retry: 1,
  });
};

/**
 * Get single CMS page by ID
 */
export const useCmsPage = (cmsPageId) => {
  return useQuery({
    queryKey: ['cmsPages', cmsPageId],

    queryFn: async () => {
      try {
        return await cmsServices.getCmsPageById(cmsPageId);
      } catch (error) {
        throw parseApiError(error);
      }
    },

    enabled: !!cmsPageId,

    staleTime: 5 * 60 * 1000,

    retry: 1,
  });
};